export const FEATURE_FLAGS = {
  Source_Feature_Trigger_Scheduler: "Source_Feature_Trigger_Scheduler",
  Resources_Feature_Module_V1_Enabled: "Resources_Feature_Module_V1_Enabled",
  Organiser_Feature_Module_V1_Enabled: "Organiser_Feature_Module_V1_Enabled",
  Devices_Feature_Module_V1_Enabled: "Devices_Feature_Module_V1_Enabled",
  Global_Feature_SignalR_Enabled: "Global_Feature_SignalR_Enabled",
  Resources_Feature_AI_Enabled: "Resources_Feature_AI_Enabled",
  Captain_Feature_Module_Enabled: "Captain_Feature_Module_Enabled",
  Home_Feature_EditApps_Enabled: "Home_Feature_EditApps_Enabled",
  Companies_Feature_Toggle_New_Uns_Tree_Enabled: "Companies_Feature_Toggle_New_Uns_Tree_Enabled",
  StorageHub_Feature_VisionPredictions_Enabled: "StorageHub_Feature_VisionPredictions_Enabled",
} as const;
